<template>
  <div v-if="showModal">
    <div id="modal" class="modal-mask" transition="modal">
      <div class="modal-container">
        <div style="position: relative;z-index: 111;">
          <div class="modal-popup" @click="hide()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#dae12f"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        </div>
        <div
          :id="id"
          style="margin: 0 auto;position:relative;width: 100%;"
          ref="adsBox"
        ></div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
/* eslint-disable */
// import PopupInterstitial from "../ads/popupInterstitial";
export default {
  data() {
    return {
      showModal: false,
      count: 0,
    };
  },
  props: { size: Array, path: String, id: String },
  beforeCreate() {
    if (process.browser) {
      window.googletag = window.googletag || { cmd: [] };

      // window.googletag.cmd.push(() => {
      //   window.googletag.destroySlots();
      // });
    }
  },
  methods: {
    hide() {
      this.showModal = false;
      document.body.style.overflow = "auto"; // ADD THIS LINE
      document.body.style.height = "auto"; // ADD THIS LINE
    },
    getHeight() {
      return this.$refs.adsBox.clientHeight;
    },
    getAdsDetails() {
      var vm = this;
      const elementId = vm.id;
      window.googletag.cmd.push(() => {
        window.googletag
          .defineSlot(vm.path, vm.size, vm.id)
          .addService(window.googletag.pubads())
          .setCollapseEmptyDiv(true);
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
        window.googletag.pubads().refresh();
      });

      setTimeout(() => {
        window.googletag.display(vm.id);
        vm.showModal = true;
        document.body.style.overflow = "hidden"; // ADD THIS LINE
        document.body.style.height = "100%"; // ADD THIS LINE
      }, 300);

      setTimeout(() => {
        // This listener will be called when a slot has finished rendering.
        window.googletag
          .pubads()
          .addEventListener("slotRenderEnded", function(event) {
            const slotId = event.slot.getSlotElementId();
            const isEmpty = event.isEmpty;
            if (slotId === elementId) {
              if (!isEmpty) {
                vm.showModal = true;
              } else {
                vm.showModal = false;
                document.body.style.overflow = "auto"; // ADD THIS LINE
                document.body.style.height = "auto"; // ADD THIS LINE
              }
            }
          });
      }, 1200);
    },
  },
  mounted() {
    this.$watch("$refs.popupVisible.style", (new_value, old_value) =>
      console.log("i")
    );
    var vm = this;
    setTimeout(() => {
      if (vm.path && vm.size && vm.id) {
        this.getAdsDetails();
      }
    }, 600);
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: auto;
  max-width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-popup {
  position: absolute;
  right: -14px;
  top: -14px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
